import React from "react";

import styles from "./grid.module.scss";

export interface GridProps {
  surfaceHeightUnits: number;
  adjustedViewBoxX: number;
  adjustedViewBoxY: number;
  adjustedViewBoxWidth: number;
  adjustedViewBoxHeight: number;
}

export const Grid = ({
  surfaceHeightUnits,
  adjustedViewBoxX,
  adjustedViewBoxY,
  adjustedViewBoxWidth,
  adjustedViewBoxHeight,
}: GridProps) => {
  return (
    <>
      <defs>
        <pattern
          id="grid"
          className={styles.grid}
          width={`${100 / 16.7}%`}
          height={`${100 / (15.7 * (surfaceHeightUnits / 47))}%`}
        >
          <rect x="0" y="0" width="100%" height="100%" fill="none" strokeWidth={0.1} />
        </pattern>
      </defs>

      <rect
        x={adjustedViewBoxX}
        y={adjustedViewBoxY}
        width={adjustedViewBoxWidth}
        height={adjustedViewBoxHeight}
        fill="url(#grid)"
      />
    </>
  );
};
